module.exports = __webpack_public_path__ + "assets/0ebe0c758ff6883ea1989887b3f47dd1.png";